import PropTypes from 'prop-types'
import React from 'react'
import KanBoIcon from 'components/KanBoIcon'
import Scrollbars from 'components/Scrollbars'
import {
  ContentHeader,
  ContentTitle,
} from 'components/Content'
import Content from '../../Content'
import ElementContentIcon from '../../ContentIcon'
import {
  ToggleModal
} from 'components/Modal'
import {
  ListItem
} from 'components/List'
import styled from 'styled-components'
import { withBoardPermission } from 'dataProviders/Board'
import { FormattedMessage } from 'components/Intl'

const Modal = styled(Scrollbars)`
  width: 300px;
  max-height: 300px;
  background-color: #eceff1;
  border-radius: 5px;
`

const ContentTitleLabel = styled(ContentTitle)`
  flex: 0 0 auto;
  margin-right: 1em;
`

const ContentTitleValue = styled(ContentTitle)`
  flex: 0 1 auto;
  margin-left: auto;
  margin-right: 1em;
  font-weight: normal !important;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export class List extends React.Component {
  static propTypes = {
    cardContext: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    isArchived: PropTypes.bool.isRequired,
    listId: PropTypes.number,
    lists: PropTypes.array.isRequired,
    listsById: PropTypes.object.isRequired,

    requestChangeCardList: PropTypes.func.isRequired
  }

  handleToggleModalRef = (ref) => {
    this.toggleModalRef = ref
  }

  renderListName = () => {
    const {
      listId,
      listsById,
    } = this.props

    return (
      <Content>
        <ContentHeader>
          <ElementContentIcon>
            <KanBoIcon name='kanbo-24-list' />
          </ElementContentIcon>
          <ContentTitleLabel>
            <FormattedMessage id='LIST' />
          </ContentTitleLabel>
          <ContentTitleValue>
            {listId ? (
              listsById[listId].name
            ) : (
              <i><FormattedMessage id='CARD_LIST_NONE' /></i>
            )}
          </ContentTitleValue>
        </ContentHeader>
      </Content>
    )
  }

  renderListSelection = () => {
    const {
      cardContext,

      listId,
      lists,
      listsById,

      requestChangeCardList
    } = this.props

    return (
      <ToggleModal
        backdrop
        ref={this.handleToggleModalRef}
        attachment='top left'
        targetAttachment='top left'
        constraints={[
          {
            to: 'window',
            pin: true
          }
        ]}
      >
        {this.renderListName()}
        <Modal>
          <ListItem
            key='null'
            active={listId === null}
            onClick={() => {
              requestChangeCardList({
                cardId: cardContext.id,
                listId: null
              })

              this.toggleModalRef.close()
            }}
          >
            <i><FormattedMessage id='CARD_LIST_NONE' /></i>
          </ListItem>
          {lists.map(id => {
            const list = listsById[id]

            const onListClick = () => {
              requestChangeCardList({
                cardId: cardContext.id,
                listId: list.id
              })

              this.toggleModalRef.close()
            }

            return (
              <ListItem
                key={list.id}
                active={list.id === listId}
                onClick={onListClick}
              >
                {list.name}
              </ListItem>
            )
          })}
        </Modal>
      </ToggleModal>
    )
  }

  render () {
    const {
      permission,
      isArchived,
      lists,
    } = this.props

    if (isArchived || lists.length === 0) return null

    return (
      <Content>
        {(!isArchived && permission.member)
          ? this.renderListSelection()
          : this.renderListName()
        }
      </Content>
    )
  }
}

export default withBoardPermission(List)
